import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  doc: {
    fontFamily: 'Open Sans'
  },
  values: {
    flexDirection: 'row',
    marginBottom: '5px'
  },
  descripcion: {
    fontWeight: 'normal'
  },
  capaTitle: {
    color: '#C00000',
    marginBottom: '3px',
    fontSize: 12,
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  capaSubTitle: {
    fontSize: 8,
    marginBottom: '10px',
    fontWeight: 'bold'
  },
  bold: {
    fontWeight: 'bold'
  },
  capaWrap: {
    fontSize: 8,
    borderBottomStyle: 'solid',
    borderBottomColor: '#E9E9E9',
    borderBottomWidth: '1px',
    paddingBottom: '5',
    marginTop: '5'
  },
  mapPage: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '20px'
  },
  header: {
    paddingTop: '10px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  },
  gencatLogo: {
    width: '100px'
  },
  dataText: {
    fontSize: 8
  },
  infoBody: {
    fontSize: 8,
    backgroundColor: '#E9E9E9'
  },
  infoBodyText: {
    padding: '3px 5px'
  }
});
